import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import BasketIcon from '../icons/BasketIcon';
import AddedIcon from '../icons/AddedIcon';
import ArrowIcon from '../icons/ArrowSendIcon';

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
}));

export default function CardButton(props) {
  const classes = useStyles();

  const ColorButton = withStyles((theme) => ({
    root: {
      width: '100%',
      // color: theme.palette.getContrastText(purple[500]),
      borderRadius: 48,
      height: 56,
      // boxShadow: '0px 6px 24px rgba(235, 80, 94, 0.4)',
      fontFamily: 'Cera CY',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '18px',
      lineheight: '23px',
      textTransform: 'none',
      color: props.color ? props.color : '#FFFFFF',
      backgroundColor: props.bgcolor,
      boxShadow: props.shadow,
      '&:hover': {
        backgroundColor: props.hbgcolor ? props.hbgcolor : props.bgcolor,
        boxShadow: props.hshadow ? props.hshadow : props.shadow,
      },
    },

    disabled: {
      color: props.discolor ? props.discolor : 'rgba(0, 0, 0, 0.26)',
      backgroundColor: props.disbgcolor ? props.disbgcolor : '#EEEEF5 !important'
    }
  }))(Button);

  return (
    <ColorButton
      variant="contained"
      color="primary"
      className={classes.margin}
      style={{ marginLeft: 0, marginRight: 0, marginTop: props.mt ? props.mt : '' }}
      onClick={props.func ? props.func : ''}
      disabled={props.disabled}
    >
      <span style={{ marginRight: 8 }}>
        {
          props.icon === 1
            ?
            <BasketIcon fill='#FFFFFF' />
            :
            props.icon === 2
              ?
              <ArrowIcon fill={props.color ? props.color : '#FFFFFF'} />
              :
              <AddedIcon fill={props.color ? props.color : '#FFFFFF'} />
        }
      </span>
      {props.text}
    </ColorButton>
  );
}